<template>
  <div class="responsive-wrapper">
    <div class="responsive-wrapper__inner" v-if="responsive">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import debounce from 'lodash.debounce'

  export default {
    props: {
      debounce: { type: Number, default: 200 },
      breakpoints: { type: Object, default: () => ({ all: [0, 99999] }) }
    },
    mounted () {
      this.resize()
      this.resize = debounce(this.resize.bind(this), this.debounce)
      window.addEventListener('resize', this.resize)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resize)
    },
    methods: {
      calc () {
        const vw = window.innerWidth
        const vh = window.innerHeight

        const breakpoint = Object.entries(this.breakpoints).reduce((acc, [key, breakpoint]) => {
          if (vw >= breakpoint[0] && vw <= breakpoint[1]) acc = key
          return acc
        }, null)

        return { vw, vh, breakpoint }
      },
      resize () {
        this.$store.commit('resized', this.calc())
      }
    }
  }
</script>
